export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore();
  const config = useRuntimeConfig();
  const base_api = config.public.apiUri;

  if (!userStore.token) {
    if (userStore.refreshToken) {
      var res = await userStore.apiRefresh({
        token: userStore.refreshToken,
      });
      if (res.error) {
        return await navigateTo("/");
      }
    } else {
      return await navigateTo("/");
    }
  } else {
    const { data, error } = await useFetch(`${base_api}/check_token`, {
      key: "checkToken",
      method: "get",
      headers: { Authorization: `Bearer ${userStore.token}` },
    });

    if (error.value) {
      userStore.setToken(null);
      userStore.setUser(null);
      userStore.setRefreshToken(null);
      return await navigateTo("/");
    }

    if (!userStore.user) {
      return await navigateTo("/");
    }
  }
});
